import { multiFactor, type User } from 'firebase/auth';

/** SSO-Konten sind von der MFA-Pflicht ausgenommen: Die Identität prüft der SSO-Provider (Claim `ssoUser` in den Regeln). */
export const isSsoAccount = (user: User | null) =>
    !!user?.providerData.some(p => p.providerId?.startsWith('saml.') || p.providerId?.startsWith('oidc.'));

/** Hat das Konto einen zweiten Faktor eingerichtet? */
export const hasSecondFactor = (user: User | null) => !!user && multiFactor(user).enrolledFactors.length > 0;
